import { render, staticRenderFns } from "./DragVertical.vue?vue&type=template&id=edc80f9e&"
import script from "./DragVertical.vue?vue&type=script&lang=js&"
export * from "./DragVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports